import { useMemo } from 'react';
import { Table } from '@shared/components';
import type { SummariesState } from '../../hooks/useFundAccountPostingsLine';
import type { AgreementSummary } from '../../types/fundAccountPostings.types';
import type { PostingDisplayRow } from '../../utils/postingDisplayRows';
import { POSTINGS_FIGURE_COLUMN_PX, POSTINGS_TABLE_MIN_WIDTH_CLASS, type PostingsLayout } from '../../utils/postingsLayout';
import { POSTINGS_COLUMNS, type PostingsTableMeta } from './postingsColumns';

interface Props {
    rows: PostingDisplayRow[];
    summaries: Map<string, AgreementSummary>;
    summariesState: SummariesState;
    layout: PostingsLayout;
    currency: string;
}

const rowId = (row: PostingDisplayRow): string => row.id;

export function FundAccountPostingsDataTable({ rows, summaries, summariesState, layout, currency }: Props) {
    const meta = useMemo<PostingsTableMeta>(
        () => ({ summaries, summariesState, currency }),
        [summaries, summariesState, currency],
    );
    return (
        <Table<PostingDisplayRow>
            data={rows}
            columns={POSTINGS_COLUMNS[layout]}
            className={POSTINGS_TABLE_MIN_WIDTH_CLASS[layout]}
            columnWidths={POSTINGS_FIGURE_COLUMN_PX}
            meta={meta}
            getRowId={rowId}
            enableSorting={false}
            emptyMessage="No postings on this page."
        />
    );
}
